import EditToolsEnum from "../../../types/EditToolsEnum";
import { IToolsState } from "../../../types/IToolsState";

/**
 * What the user last picked in the Bay Edit toolbar, so moving to another Bay
 * doesn't start over. It holds the user's choice, not the effective selection:
 * a Bay that blocks 40'+ filters them out on screen, but they come back in the
 * next Bay that allows them.
 *
 * One slot only: editing another vessel resets it to the defaults.
 */
export interface IBayEditToolsMemory {
  activeTool: EditToolsEnum;
  tools: IToolsState["tools"];
}

let memory: (IBayEditToolsMemory & { vesselKey: string }) | undefined;

/** Returns the choices stored for this vessel, dropping any left by another one */
export function recallBayEditTools(vesselKey: string): IBayEditToolsMemory | undefined {
  if (memory === undefined) return undefined;

  if (memory.vesselKey !== vesselKey) {
    memory = undefined;
    return undefined;
  }

  return { activeTool: memory.activeTool, tools: cloneTools(memory.tools) };
}

export function rememberBayEditTools(
  vesselKey: string,
  activeTool: EditToolsEnum,
  tools: IToolsState["tools"],
) {
  memory = { vesselKey, activeTool, tools: cloneTools(tools) };
}

export function forgetBayEditTools() {
  memory = undefined;
}

function cloneTools(tools: IToolsState["tools"]): IToolsState["tools"] {
  const copy = {} as IToolsState["tools"];
  (Object.keys(tools) as unknown as EditToolsEnum[]).forEach((k) => {
    copy[k] = [...tools[k]];
  });
  return copy;
}
